import { TextField, styled } from "@mui/material";

import { NumericFormat } from "react-number-format";
import { formatPrice } from "utils/helpers/numbers";
import useNotify from "hooks/useNotify";

function PriceInput({
  value,
  onChange,
  maxDecimal,
  coinName,
  min,
  max,
  placeholderPlacement = "left",
  allowNegative = false,
  showPrefix = true,
  disableBlur = false,
  ...props
}) {
  const notify = useNotify();

  const checkMaxValue = (values) => {
    const { floatValue } = values;

    if (max || max === 0) {
      const checkIfValueIsBiggerThanMaximum =
        floatValue <= max || floatValue === 0 || !floatValue;

      if (!checkIfValueIsBiggerThanMaximum) {
        notify(
          `حداکثر مقدار مجاز ${formatPrice(
            max?.toString() || "0"
          )} ${coinName} می‌باشد.`,
          "error"
        );
        onChange(max);
      }

      return checkIfValueIsBiggerThanMaximum;
    }

    return true;
  };

  const handleMinimumAmount = () => {
    const minimumAmountIsLessThanMaximumAmount = min <= max;
    const maximumAmountIsLessThanMinimumAmount = min > max;

    if (maximumAmountIsLessThanMinimumAmount) {
      const valueIsLessThanMinimum = value && value > max;

      if (valueIsLessThanMinimum) {
        onChange(max);
      }
    } else if (minimumAmountIsLessThanMaximumAmount) {
      const valueIsLessThanMinimum = value && value < min;

      if (valueIsLessThanMinimum) {
        onChange(min);
      }
    }
  };

  return (
    <NumericFormat
      value={value}
      placeholderPlacement={placeholderPlacement}
      customInput={TextFieldStyle}
      allowNegative={allowNegative}
      decimalScale={maxDecimal >= 0 ? maxDecimal : 0}
      valueIsNumericString={true}
      prefix={showPrefix ? `${coinName} ` : ""}
      thousandsGroupStyle=","
      thousandSeparator={true}
      onValueChange={(values) => {
        onChange(values.value);
      }}
      isAllowed={checkMaxValue}
      onBlur={!disableBlur && handleMinimumAmount}
      {...props}
    />
  );
}

const TextFieldStyle = styled(TextField)(
  ({ textAlign, placeholderPlacement }) => ({
    textAlign,

    input: {
      "&::placeholder": {
        textAlign: placeholderPlacement,
      },
    },
  })
);

export default PriceInput;
